import axios from 'axios';
import { headers, baseUrl, extendHeaders } from "./HelpService";


const PageUrl = baseUrl + 'reports/';

const uploadReports = (accountId, files): Promise<Response | null> => {
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
        formData.append(i.toString(), files[i]);
    }

    formData.append("account_id", accountId);
    return fetch(PageUrl + "upload/", {
        method: "POST",
        headers: headers(),
        body: formData
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const downloadReport = (accountId, reportType) => {
    const queryParams = new URLSearchParams();
    queryParams.set('account_id', accountId);
    queryParams.set('report_type', reportType);

    return fetch(PageUrl + `downloadReport/?${queryParams.toString()}`,
        {
            method: "GET",
            headers: headers()
        }
    ).then((response) => response.blob())
        .catch(error => { return null; });

};

const getLastUpdateDateReport = (accountId, reportType) => {
    const queryParams = new URLSearchParams();
    queryParams.set('account_id', accountId);
    queryParams.set('report_type', reportType);

    return fetch(PageUrl + `getLastUpdateDate/?${queryParams.toString()}`, {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};

const ReportsService = {
    uploadReports,
    downloadReport,
    getLastUpdateDateReport
};

export default ReportsService;
